
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getContactPhoneNumber } from "@/app/utils/EnvConfig";

@Component
export default class PasswordPhone extends Vue {

    private get content(): string {
        return this.$localize("pwd.set.phone.message", getContactPhoneNumber());
    }
}
